export { getTitle } from "./getTitle";
